import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {cacheService} from "../../services/cacheService";
import {loadingStore} from "../../store/loadingStore";
import {translationStore} from "../../store/translationStore";
import Logo from "../../assets/images/bet-logo-black.svg";
import NotFoundGif from "../../assets/images/404.svg";
import "./index.scss";

const NotFound = observer(() => {
    const {translationData} = translationStore;
    const {toggleUnityLoading, toggleCubeMapLoading, toggleTranslateLoading} = loadingStore;

    useEffect(() => {
        toggleUnityLoading(false);
        toggleCubeMapLoading(false);
        toggleTranslateLoading(false);
    }, [])

    const handleNavigate = () => {
        const token = cacheService.get("Authorization")
        if (token) {
            window.location.assign("/dashboard");
        } else {
            window.location.assign("/");
        }
    }

    return (
        <div className="not-found-inner-container">
            <div className="not-found-page">
                <img className="bet-logo" src={Logo} alt="Logo"/>
                <img className="not-found-page-scrap" src={NotFoundGif} alt="Logo"/>
                <div className="not-found-outer-container">
                    <h3>{translationData?.["page_not_found"]}</h3>
                    <p className="not-found-content">{translationData?.["never_exist"]}</p>
                    <button className="not-found-btn" onClick={handleNavigate}>{translationData?.["home"]}</button>
                </div>
            </div>
        </div>
    );
})

export default NotFound;
